// app/javascript/controllers/youtube_popup_controller.js
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="youtube-popup"
export default class extends Controller {
  static values = {
    autoplay: { type: Number, default: 1 }
  }

  open(event) {
    event.preventDefault()
    const link = event.currentTarget.getAttribute("href")

    const videoEmbedLink = this.buildEmbedLink(link, this.autoplayValue)
    if (!videoEmbedLink) return

    // Build iframe
    const iframe = document.createElement("iframe")
    iframe.setAttribute("src", videoEmbedLink)
    iframe.setAttribute("allowfullscreen", "")
    iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture")

    // Build popup content
    const content = document.createElement("div")
    content.classList.add("YouTubePopUp-Content")

    const close = document.createElement("span")
    close.classList.add("YouTubePopUp-Close")
    close.addEventListener("click", this.close.bind(this))

    content.appendChild(close)
    content.appendChild(iframe)

    // Build wrapper
    this.wrapper = document.createElement("div")
    this.wrapper.classList.add("YouTubePopUp-Wrap", "YouTubePopUp-animation")
    this.wrapper.appendChild(content)
    this.wrapper.addEventListener("click", this.close.bind(this))

    document.body.appendChild(this.wrapper)

    setTimeout(() => {
      this.wrapper.classList.remove("YouTubePopUp-animation")
    }, 600)

    // ESC key closes popup
    this.keyHandler = (e) => {
      if (e.key === "Escape") this.close()
    }
    document.addEventListener("keyup", this.keyHandler)
  }

  close() {
    if (!this.wrapper) return
    this.wrapper.classList.add("YouTubePopUp-Hide")

    setTimeout(() => {
      this.wrapper.remove()
      this.wrapper = null
      document.removeEventListener("keyup", this.keyHandler)
    }, 515)
  }

  buildEmbedLink(url, autoplay) {
    let videoId, embedUrl

    if (url.match(/(youtube\.com)/)) {
      videoId = url.split("v=")[1]?.split("&")[0]
      embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=${autoplay}`
    } else if (url.match(/(youtu\.be)/)) {
      videoId = url.split("/")[3]
      embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=${autoplay}`
    } else if (url.match(/(vimeo\.com\/)+[0-9]/)) {
      videoId = url.split("/")[3]
      embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=${autoplay}`
    } else if (url.match(/(vimeo\.com\/)+[a-zA-Z]/)) {
      videoId = url.split("/")[5]
      embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=${autoplay}`
    }

    return embedUrl || null
  }
}
